import React from 'react';
import styled from 'styled-components';

import Media from './media';
import CourseCard from './courseCard';

const BasicInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 24px;
	margin-top: ${props => (props.hasCustomHTML ? '8px' : '24px')};
	margin-bottom: 18px;

	@media
		${props => props.theme.device.lgDesktop},
		${props => props.theme.device.desktop}
	{
		flex-direction: row;
		margin: 24px 16px 18px;
		margin-top: ${props => (props.hasCustomHTML ? '8px' : '24px')};
	}

	@media ${props => props.theme.device.mobile} {
		margin-top: ${props => (props.hasCustomHTML ? '8px' : '52px')};
	}
`;

const BasicInfo = ({ hasCustomHTML }: { hasCustomHTML?: boolean }): JSX.Element => (
	<BasicInfoWrapper hasCustomHTML={hasCustomHTML}>
		<Media />
		<CourseCard />
	</BasicInfoWrapper>
);

export default BasicInfo;
